import { c as _c } from "react-compiler-runtime";
import { useEffect, useState, useMemo, useRef, useCallback } from 'react';
import { USER_ATTRIBUTES } from 'collaboration-sidebar/constants/userAttributes';
import useUserSettings from 'collaboration-sidebar/hooks/useUserSettings';
import { getAssetKeyFromAsset } from 'collaboration-sidebar/utils/multipleAssets';
import COMMENT_TYPES from '../../../constants/CommentTypes';
import useHasCommentingFeature, { useHasDeepCommentingFeature } from '../../../hooks/useHasCommentingFeature';
import { useRealtimeCommentHandler } from '../../../hooks/useHasUnreadComments';
import { useCollaborationSidebarActions, useStateValue } from 'collaboration-sidebar/store/collaborationSidebarProvider';
import * as commentingApi from '../../../api/CommentingV3';
export default function useSetUpEmbeddedComments() {
  "use memo";

  const $ = _c(27);
  const {
    getUserSetting,
    hasLoaded: userSettingsLoaded
  } = useUserSettings();
  const hasCommentingFeature = useHasCommentingFeature();
  const hasDeepCommentingFeature = useHasDeepCommentingFeature();
  const {
    setModulesWithReplies,
    mergeReplyCounts,
    setHideEmbeddedComments
  } = useCollaborationSidebarActions();
  const objectId = useStateValue("objectId");
  const objectType = useStateValue("objectType");
  const isCommentModeActive = useStateValue("isCommentModeActive");
  const assetKeyWithFetchedReplies = useRef(null);
  const [hasInitializedHideIndicators, setHasInitializedHideIndicators] = useState(false);
  let t0;
  if ($[0] !== getUserSetting || $[1] !== userSettingsLoaded) {
    t0 = userSettingsLoaded ? getUserSetting(USER_ATTRIBUTES.HIDE_COLLABORATION_SIDEBAR_EMBEDDED_COMMENTS.key) === "true" : true;
    $[0] = getUserSetting;
    $[1] = userSettingsLoaded;
    $[2] = t0;
  } else {
    t0 = $[2];
  }
  const hideIndicators = t0;
  let t1;
  if ($[3] !== hasDeepCommentingFeature || $[4] !== hideIndicators || $[5] !== isCommentModeActive || $[6] !== mergeReplyCounts || $[7] !== objectId || $[8] !== objectType || $[9] !== setModulesWithReplies) {
    t1 = async stale => {
      if (!hasDeepCommentingFeature) {
        return;
      }
      const assetKey = getAssetKeyFromAsset({
        objectId: objectId || "",
        objectType: objectType || ""
      });
      if ((!hideIndicators || isCommentModeActive) && objectId && objectType && (assetKeyWithFetchedReplies.current !== assetKey || stale)) {
        var _response$results$fil, _response$results;
        const response = await commentingApi.fetchCommentsCached({
          objectType,
          objectId,
          refetch: !!stale
        });
        const replyComments = (_response$results$fil = (_response$results = response.results) === null || _response$results === void 0 ? void 0 : _response$results.filter(_temp)) !== null && _response$results$fil !== void 0 ? _response$results$fil : [];
        const replyCommentsMap = replyComments.reduce(_temp2, {});
        assetKeyWithFetchedReplies.current = assetKey;
        setModulesWithReplies(replyCommentsMap);
        const latestReplyCounts = await commentingApi.fetchCommentRepliesCount({
          objectType,
          objectId,
          commentIds: replyComments.map(_temp3)
        });
        mergeReplyCounts(latestReplyCounts);
      }
    };
    $[3] = hasDeepCommentingFeature;
    $[4] = hideIndicators;
    $[5] = isCommentModeActive;
    $[6] = mergeReplyCounts;
    $[7] = objectId;
    $[8] = objectType;
    $[9] = setModulesWithReplies;
    $[10] = t1;
  } else {
    t1 = $[10];
  }
  const fetchEmbeddedComments = t1;
  const t2 = objectType || undefined;
  const t3 = objectId || undefined;
  const t4 = !hasCommentingFeature;
  let t5;
  if ($[11] !== fetchEmbeddedComments) {
    t5 = () => void fetchEmbeddedComments(true);
    $[11] = fetchEmbeddedComments;
    $[12] = t5;
  } else {
    t5 = $[12];
  }
  let t6;
  if ($[13] !== t2 || $[14] !== t3 || $[15] !== t4 || $[16] !== t5) {
    t6 = {
      objectType: t2,
      objectId: t3,
      skip: t4,
      callback: t5
    };
    $[13] = t2;
    $[14] = t3;
    $[15] = t4;
    $[16] = t5;
    $[17] = t6;
  } else {
    t6 = $[17];
  }
  useRealtimeCommentHandler(t6);
  let t7;
  let t8;
  if ($[18] !== fetchEmbeddedComments) {
    t7 = () => {
      fetchEmbeddedComments().catch(_temp4);
    };
    t8 = [fetchEmbeddedComments];
    $[18] = fetchEmbeddedComments;
    $[19] = t7;
    $[20] = t8;
  } else {
    t7 = $[19];
    t8 = $[20];
  }
  useEffect(t7, t8);
  let t10;
  let t9;
  if ($[21] !== hasInitializedHideIndicators || $[22] !== hideIndicators || $[23] !== setHideEmbeddedComments || $[24] !== userSettingsLoaded) {
    t9 = () => {
      if (!hasInitializedHideIndicators && userSettingsLoaded) {
        setHideEmbeddedComments(hideIndicators);
        setHasInitializedHideIndicators(true);
      }
    };
    t10 = [hasInitializedHideIndicators, hideIndicators, userSettingsLoaded, setHideEmbeddedComments];
    $[21] = hasInitializedHideIndicators;
    $[22] = hideIndicators;
    $[23] = setHideEmbeddedComments;
    $[24] = userSettingsLoaded;
    $[25] = t10;
    $[26] = t9;
  } else {
    t10 = $[25];
    t9 = $[26];
  }
  useEffect(t9, t10);
}
function _temp4(__e) {}
function _temp3(comment_1) {
  return comment_1.id;
}
function _temp2(repliesAcc, comment_0) {
  var _comment_0$parentId;
  repliesAcc[(_comment_0$parentId = comment_0.parentId) !== null && _comment_0$parentId !== void 0 ? _comment_0$parentId : ""] = comment_0;
  return repliesAcc;
}
function _temp(comment) {
  return comment.type === COMMENT_TYPES.DEEP_COMMENT && comment.parentId;
}